// French (`fr`) shell baseline
import { layoutFr } from './fr/layout'
import { homeFr } from './fr/home'
import { playFr } from './fr/play'
import { demoFr } from './fr/demo'
import { booksFr } from './fr/books'
import { commerceFr } from './fr/commerce'
import { communityFr } from './fr/community'
import { dashboardFr } from './fr/dashboard'
import { authFr } from './fr/auth'
import { marketingFr } from './fr/marketing'
import { worldFr } from './fr/world'
import { encyclopediaFr } from './fr/encyclopedia'
import { systemFr } from './fr/system'
import { cityFr } from './fr/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const baseFr: MessageCatalog = {
  ...layoutFr,
  ...homeFr,
  ...playFr,
  ...demoFr,
  ...booksFr,
  ...commerceFr,
  ...communityFr,
  ...dashboardFr,
  ...authFr,
  ...marketingFr,
  ...worldFr,
  ...encyclopediaFr,
  ...systemFr,
  ...cityFr,
}
